"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setUserPref = setUserPref;
exports.getUserPref = getUserPref;
exports.setUserOrgPref = setUserOrgPref;
exports.getUserOrgPref = getUserOrgPref;
exports.setOrgPref = setOrgPref;
exports.getOrgPref = getOrgPref;
exports.setDevicePref = setDevicePref;
exports.getDevicePref = getDevicePref;
const logging_1 = require("./logging");
/**
 *
 * @description Sets a preference for a user which is consistent across devices and organisations (CURRENTLY UNIQUE TO DEVICE/INSTALLATION)
 * @param prefNamespace The namespace of the preference, of type globalUserPrefNamespace
 * @param key The key for the preference to change
 * @param value The value to be set
 */
function setUserPref(prefNamespace, key, value) {
    try {
        let userPrefs = JSON.parse(localStorage.getItem('userPreferences'));
        if (userPrefs !== undefined && userPrefs !== null) {
            try {
                const newPrefObject = {
                    ...userPrefs,
                    [prefNamespace]: {
                        ...userPrefs[prefNamespace],
                        [key]: value,
                    },
                };
                localStorage.setItem('userPreferences', JSON.stringify(newPrefObject));
            }
            catch {
                (0, logging_1.spErrorTags)('Namespace or key provided does not match the prefs', ['preferences', 'userPreferences']);
            }
        }
        else {
            userPrefs = {
                account: {},
                teampage: {},
                rocketchat: {},
                homepage: {},
                itinerary: {},
                component: {},
            };
            try {
                const newPrefObject = {
                    ...userPrefs,
                    [prefNamespace]: {
                        ...userPrefs[prefNamespace],
                        [key]: value,
                    },
                };
                localStorage.setItem('userPreferences', JSON.stringify(newPrefObject));
            }
            catch {
                (0, logging_1.spErrorTags)('Namespace or key provided does not match the prefs', ['preferences', 'userPreferences']);
            }
        }
    }
    catch {
        (0, logging_1.spErrorTags)('Error setting user pref', [
            'preferences',
            'userPreferences',
        ]);
    }
}
/**
 *
 * @description Gets a preference for a user which is consistent across devices and organisations
 * @param prefNamepace The namespace of the preference, of type globalUserPrefNamespace
 * @param key The key of the value to return
 */
function getUserPref(prefNamespace, key) {
    try {
        const userPrefs = JSON.parse(localStorage.getItem('userPreferences'));
        if (userPrefs) {
            if (userPrefs[prefNamespace] !== undefined &&
                userPrefs[prefNamespace] !== null) {
                if (userPrefs[prefNamespace][key] !== undefined &&
                    userPrefs[prefNamespace][key] !== null) {
                    return userPrefs[prefNamespace][key];
                }
                else {
                    return undefined;
                }
            }
            else {
                return undefined;
            }
        }
        else {
            return undefined;
        }
    }
    catch {
        (0, logging_1.spErrorTags)('Error getting prefs', ['preferences', 'userPreferences']);
        return undefined;
    }
}
/**
 *
 * @description Sets a preference for a user which is unique to an organisation
 * @param prefNamespace The namespace of the preference, of type globalUserPrefNamespace
 * @param key The key for the preference to change
 * @param value The value to be set
 * @param orgID The id of the organistation to set the preference for
 */
function setUserOrgPref(prefNamespace, key, value, orgID) {
    try {
        let userOrgPrefs = JSON.parse(localStorage.getItem('userOrgPreferences'));
        if (userOrgPrefs !== undefined && userOrgPrefs !== null) {
            try {
                let prefsForOrg = userOrgPrefs[orgID];
                if (prefsForOrg !== undefined && prefsForOrg !== null) {
                    const newPrefObject = {
                        ...userOrgPrefs,
                        [orgID]: {
                            ...prefsForOrg,
                            [prefNamespace]: {
                                ...prefsForOrg[prefNamespace],
                                [key]: value,
                            },
                        },
                    };
                    localStorage.setItem('userOrgPreferences', JSON.stringify(newPrefObject));
                }
                else {
                    prefsForOrg = {
                        account: {},
                        teampage: {},
                        rocketchat: {},
                        homepage: {},
                        itinerary: {},
                        component: {},
                    };
                    const newPrefObject = {
                        ...userOrgPrefs,
                        [orgID]: {
                            ...prefsForOrg,
                            [prefNamespace]: {
                                ...prefsForOrg[prefNamespace],
                                [key]: value,
                            },
                        },
                    };
                    localStorage.setItem('userOrgPreferences', JSON.stringify(newPrefObject));
                }
            }
            catch {
                (0, logging_1.spErrorTags)('Namespace, key, or orgID provided does not match the preferences', ['preferences', 'userOrgPreferences']);
            }
        }
        else {
            const prefsForOrg = {
                account: {},
                teampage: {},
                rocketchat: {},
                homepage: {},
                itinerary: {},
                component: {},
            };
            userOrgPrefs = {
                [orgID]: prefsForOrg,
            };
            try {
                const newPrefObject = {
                    ...userOrgPrefs,
                    [orgID]: {
                        ...prefsForOrg,
                        [prefNamespace]: {
                            ...prefsForOrg[prefNamespace],
                            [key]: value,
                        },
                    },
                };
                localStorage.setItem('userOrgPreferences', JSON.stringify(newPrefObject));
            }
            catch {
                (0, logging_1.spErrorTags)('Namespace, key, or orgID provided does not match the preferences', ['preferences', 'userOrgPreferences']);
            }
        }
    }
    catch {
        (0, logging_1.spErrorTags)('Error setting user org preferences', [
            'preferences',
            'userOrgPreferences',
        ]);
    }
}
/**
 *
 * @description Gets a preference for a user which is unique to an organisation
 * @param prefNamespace The namespace of the preference, of type globalUserPrefNamespace
 * @param key The key of the value to return
 * @param orgID The id of the organistation to set the preference for
 */
function getUserOrgPref(prefNamespace, key, orgID) {
    try {
        const userOrgPrefs = JSON.parse(localStorage.getItem('userOrgPreferences'));
        if (userOrgPrefs) {
            const prefsForOrg = userOrgPrefs[orgID];
            if (prefsForOrg !== undefined && prefsForOrg !== null) {
                if (prefsForOrg[prefNamespace] !== undefined &&
                    prefsForOrg[prefNamespace] !== null) {
                    if (prefsForOrg[prefNamespace][key] !== undefined &&
                        prefsForOrg[prefNamespace][key] !== null) {
                        return prefsForOrg[prefNamespace][key];
                    }
                    else {
                        return undefined;
                    }
                }
                else {
                    return undefined;
                }
            }
            else {
                return undefined;
            }
        }
        else {
            return undefined;
        }
    }
    catch {
        (0, logging_1.spErrorTags)('Error getting prefs', [
            'preferences',
            'userOrgPreferences',
        ]);
        return undefined;
    }
}
/**
 *
 * @description Sets a default preference for each user within an organisation
 * @param prefNamespace The namespace of the preference, of type globalUserPrefNamespace
 * @param key The key for the preference to change
 * @param value The value to be set
 * @param orgID The id of the organistation to set the preference for
 */
function setOrgPref(key, value, orgID) {
    const pref = null;
}
/**
 *
 * @description Gets a default preference for an organisation
 * @param prefNamespace The namespace of the preference, of type globalUserPrefNamespace
 * @param key The key of the value to return
 * @param orgID The id of the organistation to set the preference for
 */
function getOrgPref(key, orgID) {
    const pref = null;
    return pref;
}
/**
 *
 * @description Sets a default preference fwhich is unique to the users current device
 * @param prefNamespace The namespace of the preference, of type globalUserPrefNamespace
 * @param key The key for the preference to change
 * @param value The value to be set
 * @param deviceID The id of the device to set the preference for
 */
function setDevicePref(key, value, device) {
    try {
        let devicePrefs = JSON.parse(localStorage.getItem('devicePreferences'));
        if (devicePrefs !== undefined && devicePrefs !== null) {
            try {
                const prefsForDevice = devicePrefs[device];
                if (prefsForDevice !== undefined && prefsForDevice !== null) {
                    const newPrefObject = {
                        ...devicePrefs,
                        [device]: {
                            ...prefsForDevice[device],
                            [key]: value,
                        },
                    };
                    localStorage.setItem('devicePreferences', JSON.stringify(newPrefObject));
                }
                else {
                    const newPrefObject = {
                        ...devicePrefs,
                        [device]: {
                            ...prefsForDevice[device],
                            [key]: value,
                        },
                    };
                    localStorage.setItem('devicePreferences', JSON.stringify(newPrefObject));
                }
            }
            catch {
                (0, logging_1.spErrorTags)('Namespace, key, or orgID provided does not match the preferences', ['preferences', 'devicePreferences']);
            }
        }
        else {
            const prefsForDevice = {
                theme: '',
            };
            devicePrefs = {
                [device]: prefsForDevice,
            };
            try {
                const newPrefObject = {
                    ...devicePrefs,
                    [device]: {
                        ...devicePrefs[device],
                        [key]: value,
                    },
                };
                localStorage.setItem('devicePreferences', JSON.stringify(newPrefObject));
            }
            catch {
                (0, logging_1.spErrorTags)('Namespace, key, or orgID provided does not match the preferences', ['preferences', 'devicePreferences']);
            }
        }
    }
    catch {
        (0, logging_1.spErrorTags)('Error setting user org preferences', [
            'preferences',
            'devicePreferences',
        ]);
    }
}
/**
 *
 * @description Gets a default preference fwhich is unique to the users current device
 * @param prefNamespace The namespace of the preference, of type globalUserPrefNamespace
 * @param key The key of the value to return
 * @param deviceID The id of the device to set the preference for
 */
function getDevicePref(key, device) {
    try {
        const devicePrefs = JSON.parse(localStorage.getItem('devicePreferences'));
        if (devicePrefs) {
            const prefsForDevices = devicePrefs[device];
            if (prefsForDevices !== undefined && prefsForDevices !== null) {
                if (prefsForDevices[key] !== undefined &&
                    prefsForDevices[key] !== null) {
                    return prefsForDevices[key];
                }
                else {
                    return undefined;
                }
            }
            else {
                return undefined;
            }
        }
        else {
            return undefined;
        }
    }
    catch {
        (0, logging_1.spErrorTags)('Error getting prefs', ['preferences', 'devicePreferences']);
        return undefined;
    }
}
